import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import {
    NavigationLinkDirective,
    ShFormSelectComponent,
    ShIconModule,
    ShNotificationComponent
} from '@stylehaven/components';
import { NgLetModule } from 'ng-let';
import { SecurityGroupService } from '../services/security/security-group.service';
import { RecordSecurityGroupsEditContainerComponent } from './record-security-groups-edit/series-security-tab-edit-container/record-security-groups-edit-container.component';
import { RecordSecurityGroupsContainerComponent } from './record-security-groups-readonly/record-security-groups-container.component';
import { RecordSecurityGroupsSandboxService } from './sandbox/record-security-groups-sandbox.service';

@NgModule({
    declarations: [RecordSecurityGroupsContainerComponent, RecordSecurityGroupsEditContainerComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        ShIconModule,
        ShNotificationComponent,
        NavigationLinkDirective,
        NgLetModule,
        ShFormSelectComponent
    ],
    exports: [RecordSecurityGroupsContainerComponent, RecordSecurityGroupsEditContainerComponent],
    providers: [RecordSecurityGroupsSandboxService, SecurityGroupService]
})
export class RecordSecurityGroupsModule {}
